// extracted by mini-css-extract-plugin
export var blinkBottom = "Eye-module--blinkBottom--mnVhQ";
export var blinkEye = "Eye-module--blinkEye--KrzAI";
export var blinkTop = "Eye-module--blinkTop--rxZAf";
export var bottomLid = "Eye-module--bottomLid--yk35w";
export var movePupil = "Eye-module--movePupil--8eIfQ";
export var pupil = "Eye-module--pupil--Y-7Ld";
export var topLid = "Eye-module--topLid--uajvn";